import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import ReactSlider from "react-slider";
import { getCarsList } from "../../../features/bookings/carrentSlice";
import "./range.css";

const RentalFilter = ({ filterData, maxp, minp, maxKms, minKms }) => {
  const carsListting = useSelector(getCarsList);
  const [brandsL, setBrandL] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const [carType, setCarType] = useState([]);
  const [showbrandList, setShowBrandList] = useState(false);
  const [currentPrice, setCurrentPrice] = useState();
  const [currentKm, setCurrentKm] = useState();
  const [filterState, setfilterState] = useState({
    PriceSort: [],
    CarType: [],
    GearType: [],
    FuelType: [],
    Seats: [],
    Brand: [],
    PriceRange: [],
    KmDriven: [],
    Reset: false,
  });

  useEffect(() => {
    var b = [];
    var ct = [];
    if (carsListting.length > 0) {
      carsListting.map((v) => {
        if (!b.includes(v.cars_brand.name)) {
          b.push(v.cars_brand.name);
        }
        if (!ct.includes(v.cars_type.name)) {
          ct.push(v.cars_type.name);
        }
        setCarType(ct);
        setBrandL(b);
      });
    }
  }, [carsListting]);
  var filterTimer = "";
  const FilterHandler = (type, val) => {
    switch (type) {
      case "Reset":
        filterState[type] = true;
        filterState["PriceSort"] = [];
        filterState["CarType"] = [];
        filterState["GearType"] = [];
        filterState["FuelType"] = [];
        filterState["Seats"] = [];
        filterState["Brand"] = [];
        setfilterState(filterState);
        filterData(filterState);
        break;
      case "PriceSort":
        filterState["Reset"] = false;
        filterState[type] = [];
        filterState[type].push(val);
        setfilterState(filterState);
        filterData(filterState);
        break;
      case "PriceRange":
        clearTimeout(filterTimer);
        filterState["Reset"] = false;
        filterState["PriceRange"] = [];
        filterTimer = setTimeout(() => {
          val.map((p, i) => {
            filterState["PriceRange"].push(p);
          });
          setfilterState(filterState);
          filterData(filterState);
        }, 1000);
        break;
      case "KmDriven":
        clearTimeout(filterTimer);
        filterState["Reset"] = false;
        filterState["KmDriven"] = [];
        filterTimer = setTimeout(() => {
          val.map((p, i) => {
            filterState["KmDriven"].push(p);
          });
          setfilterState(filterState);
          filterData(filterState);
        }, 1000);
        break;

      default:
        filterState["Reset"] = false;
        const findss = filterState[type].find((f) => f === val);

        if (findss === undefined) {
          filterState[type] = [...filterState[type], val];
        } else {
          var ind = filterState[type].findIndex((f) => f === val);
          filterState[type].splice(ind, 1);
        }
        setfilterState(filterState);
        filterData(filterState);
        break;
    }
    // if (type === "Reset") {
    //   filterState[type] = true;
    //   filterState["PriceSort"] = [];
    //   filterState["CarType"] = [];
    //   filterState["GearType"] = [];
    //   filterState["FuelType"] = [];
    //   filterState["Seats"] = [];
    //   filterState["Brand"] = [];
    // }

    // if (type === "PriceSort") {
    //   filterState["Reset"] = false;
    //   filterState[type] = [];
    //   filterState[type].push(val);
    // }

    // if (type === "PriceRange") {
    //   filterState["Reset"] = false;
    //   filterState["PriceRange"] = [];
    //   val.map((p, i) => {
    //     filterState["PriceRange"].push(p);
    //   });
    // }

    // if (type === "KmDriven") {
    //   filterState["Reset"] = false;
    //   filterState["KmDriven"] = [];
    //   val.map((p, i) => {
    //     filterState["KmDriven"].push(p);
    //   });
    // }

    // if (
    //   type !== "PriceSort" &&
    //   type !== "PriceRange" &&
    //   type !== "KmDriven" &&
    //   type !== "PriceRange" &&
    //   type !== "Reset"
    // ) {
    //   filterState["Reset"] = false;
    //   const findss = filterState[type].find((f) => f === val);

    //   if (findss === undefined) {
    //     filterState[type] = [...filterState[type], val];
    //   } else {
    //     var ind = filterState[type].findIndex((f) => f === val);
    //     filterState[type].splice(ind, 1);
    //   }
    // }

    // setfilterState(filterState);
    // filterData(filterState);
  };

  const BrandHandler = (val) => {
    filterState["Reset"] = false;

    setBrandList(
      brandsL.filter((b) => b.toLowerCase().includes(val.toLowerCase()))
    );

    if (val === "") {
      setShowBrandList(false);
      setBrandList([]);
    }
  };

  useEffect(() => {
    if (brandList > 0) {
      setShowBrandList(true);
    }
  }, [brandList]);

  return (
    <>
      <div aria-label="breadcrumb">
        <ol className="breadcrumb m-0">
          <li className="breadcrumb-item">
            <Link to="/">Home</Link>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Car Rental
          </li>
        </ol>
      </div>
      <div className="fillter-container">
      <div className={`filter-wrap`}>
        <div className="filter-title">
          <h4>Sort & Filters</h4>
          <span onClick={() => FilterHandler("Reset", "0")}>Reset</span>
        </div>

        <div className="filter-inner-wrap">
          <div className="applied-filter-wrap"></div>
        </div>
      </div>
      <div className="filter-ctr">
        <h6 className="list-heading">Sort By</h6>
        <div className="list-items">
          <div className="list-wrapper">
            <div
              className={
                filterState["PriceSort"].includes("MaxToMin")
                  ? "list active"
                  : "list"
              }
              onClick={() => {
                FilterHandler("PriceSort", "MaxToMin");
              }}
            >
              <div className="filter-icons-wrap">
                <img src="/assets/images/car-rental/high-to-low.svg" alt="" />
              </div>
              <div className="text">High to Low</div>
            </div>
          </div>
          <div className="list-wrapper">
            <div
              className={
                filterState["PriceSort"].includes("MinToMax")
                  ? "list active"
                  : "list"
              }
              onClick={() => {
                FilterHandler("PriceSort", "MinToMax");
              }}
            >
              <div className="filter-icons-wrap">
                <img src="/assets/images/car-rental/low-to-high.svg" alt="" />
              </div>
              <div className="text">Low to High</div>
            </div>
          </div>
        </div>
      </div>
      <div className="filter-ctr">
        <h6 className="list-heading">FuelType</h6>
        <div className="list-items">
          <div className="list-wrapper">
            <div
              className={
                filterState["FuelType"].includes("Petrol")
                  ? "list active"
                  : "list"
              }
              onClick={() => {
                FilterHandler("FuelType", "Petrol");
              }}
            >
              <div className="filter-icons-wrap">
                <img src="/assets/images/car-rental/petrol2.svg" alt="" />
              </div>
              <div className="text">Petrol</div>
            </div>
          </div>
          <div className="list-wrapper">
            <div
              className={
                filterState["FuelType"].includes("diesel")
                  ? "list active"
                  : "list"
              }
              onClick={() => {
                FilterHandler("FuelType", "diesel");
              }}
            >
              <div className="filter-icons-wrap">
                <img src="/assets/images/car-rental/petrol2.svg" alt="" />
              </div>
              <div className="text">Diesel</div>
            </div>
          </div>
          <div className="list-wrapper">
            <div
              className={
                filterState["FuelType"].includes("Electric")
                  ? "list active"
                  : "list"
              }
              onClick={() => {
                FilterHandler("FuelType", "Electric");
              }}
            >
              <div className="filter-icons-wrap">
                <img src="/assets/images/car-rental/electric.svg" alt="" />
              </div>
              <div className="text">Electric</div>
            </div>
          </div>
          <div className="list-wrapper">
            <div
              className={
                filterState["FuelType"].includes("gas") ? "list active" : "list"
              }
              onClick={() => {
                FilterHandler("FuelType", "gas");
              }}
            >
              <div className="filter-icons-wrap">
                <img src="/assets/images/car-rental/gas.svg" alt="" />
              </div>
              <div className="text">Gas</div>
            </div>
          </div>
        </div>
      </div>
      <div className="filter-ctr">
        <h6 className="list-heading">Transmission</h6>
        <div className="list-items">
          <div className="list-wrapper">
            <div
              className={
                filterState["GearType"].includes("Manual")
                  ? "list active"
                  : "list"
              }
              onClick={() => {
                FilterHandler("GearType", "Manual");
              }}
            >
              <div className="filter-icons-wrap">
                <img src="/assets/images/car-rental/manual.svg" alt="" />
              </div>
              <div className="text">Manual</div>
            </div>
          </div>
          <div className="list-wrapper">
            <div
              className={
                filterState["GearType"].includes("Auto")
                  ? "list active"
                  : "list"
              }
              onClick={() => {
                FilterHandler("GearType", "Auto");
              }}
            >
              <div className="filter-icons-wrap">
                <img src="/assets/images/car-rental/automatic.svg" alt="" />
              </div>
              <div className="text">Auto</div>
            </div>
          </div>
        </div>
      </div>
      <div className="filter-ctr">
        <h6 className="list-heading">Car Types</h6>
        <div className="list-items">
          {carType.map((v, i) => (
            <div key={i} className="list-wrapper">
              <div
                className={
                  filterState["CarType"].includes(v) ? "list active" : "list"
                }
                onClick={() => {
                  FilterHandler("CarType", v);
                }}
              >
                <div className="filter-icons-wrap">
                  <img src="/assets/images/car-rental/hatchback.svg" alt="" />
                </div>
                <div className="text">{v}</div>
              </div>
            </div>
          ))}

          {/*
          <div className="list-wrapper">
            <div
              className={
                filterState["CarType"].includes("Hatchback")
                  ? "list active"
                  : "list"
              }
              onClick={() => {
                FilterHandler("CarType", "Hatchback");
              }}
            >
              <div className="filter-icons-wrap">
                <img src="/assets/images/car-rental/hatchback.svg" alt="" />
              </div>
              <div className="text">Hatchback</div>
            </div>
          </div>

          <div className="list-wrapper">
            <div
              className={
                filterState["CarType"].includes("XUV") ? "list active" : "list"
              }
              onClick={() => {
                FilterHandler("CarType", "XUV");
              }}
            >
              <div className="filter-icons-wrap">
                <img src="/assets/images/car-rental/suv.svg" alt="" />
              </div>
              <div className="text">SUV</div>
            </div>
          </div>
          */}
        </div>
      </div>
      <div className="filter-ctr">
        <h6 className="list-heading">Seats</h6>
        <div className="list-items">
          <div className="list-wrapper">
            <div
              className={
                filterState["Seats"].includes("4") ? "list active" : "list"
              }
              onClick={() => {
                FilterHandler("Seats", "4");
              }}
            >
              <div className="filter-icons-wrap">
                <img src="/assets/images/car-rental/seat.svg" alt="" />
              </div>
              <div className="text">4</div>
            </div>
          </div>

          <div className="list-wrapper">
            <div
              className={
                filterState["Seats"].includes("5") ? "list active" : "list"
              }
              onClick={() => {
                FilterHandler("Seats", "5");
              }}
            >
              <div className="filter-icons-wrap">
                <img src="/assets/images/car-rental/seat.svg" alt="" />
              </div>
              <div className="text">5</div>
            </div>
          </div>

          <div className="list-wrapper">
            <div
              className={
                filterState["Seats"].includes("8") ? "list active" : "list"
              }
              onClick={() => {
                FilterHandler("Seats", "8");
              }}
            >
              <div className="filter-icons-wrap">
                <img src="/assets/images/car-rental/seat.svg" alt="" />
              </div>
              <div className="text">8</div>
            </div>
          </div>
        </div>
      </div>
      <div className="filter-ctr">
        <h6 className="list-heading">brands</h6>
        <p className="p-0 m-0">Include specific cars</p>
        <p className="p-0 m-0">
          Any specific model in mind? Find it here. We will include them to
          search
        </p>
        <div className="list-items">
          <div>
            {filterState["Brand"].map((val, ind) => (
              <span key={ind} onClick={() => FilterHandler("Brand", val)}>
                {val}
                <img src="assets/images/hotel/close.svg" alt="close" />
              </span>
            ))}
          </div>
          <div className="w-100">
            <input
              type={"text"}
              onChange={(e) => {
                BrandHandler(e.target.value);
              }}
            />
            <ul className={showbrandList ? "d-none" : "d-block"}>
              {brandList.map((brand, index) => (
                <li
                  key={index}
                  onClick={() => {
                    FilterHandler("Brand", brand);
                    setShowBrandList(false);
                    setBrandList([]);
                  }}
                >
                  {brand}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <div className="filter-ctr price-range-main">
        <h6 className="list-heading">Price ($)</h6>
        {maxp > 0 ? (
          <ReactSlider
            className="horizontal-slider"
            thumbClassName="example-thumb"
            trackClassName="example-track"
            defaultValue={[minp, maxp]}
            min={parseInt(minp)}
            max={parseInt(maxp)}
            ariaLabel={["Lower thumb", "Upper thumb"]}
            ariaValuetext={(state) => `Thumb value ${state.valueNow}`}
            renderThumb={(props, state) => (
              <div {...props}>{state.valueNow}</div>
            )}
            pearling
            minDistance={10}
            onChange={([min, max]) => {
              FilterHandler("PriceRange", [min, max]);
            }}
          />
        ) : (
          ""
        )}

        <div className="range-display">{currentPrice}</div>
      </div>
      <div className="filter-ctr price-range-main">
        <h6 className="list-heading">Driven KM</h6>
        {maxKms > 0 ? (
          <ReactSlider
            className="horizontal-slider"
            thumbClassName="example-thumb"
            trackClassName="example-track"
            defaultValue={[minKms, maxKms]}
            min={minKms}
            max={maxKms}
            ariaLabel={["Lower thumb", "Upper thumb"]}
            ariaValuetext={(state) => `Thumb value ${state.valueNow}`}
            renderThumb={(props, state) => (
              <div {...props}>{state.valueNow}</div>
            )}
            pearling
            minDistance={10}
            onChange={([min, max]) => {
              FilterHandler("KmDriven", [min, max]);
            }}
          />
        ) : (
          ""
        )}
      </div>
      </div>
    </>
  );
};

export default RentalFilter;
